function FreedomPayApi() {
  const url = 'https://localhost:3000';

  this.pay = function ( amount, taxAmount, storeId, terminalId, laneId, invoiceNumber, merchantReferenceCode, clientEnvironment, items, callback) {
    let body = {};
    let methodPath = '/fcc/pay';
    body.amount = amount;
    body.taxAmount = taxAmount;
    body.storeId = storeId;
    body.terminalId = terminalId;
    body.laneId = laneId;
    body.invoiceNumber = invoiceNumber;
    body.merchantReferenceCode = merchantReferenceCode;
    body.clientEnvironment = clientEnvironment;
    body.items = items;
    $.ajax({
        url: url + methodPath,
        type: 'POST',
        contentType: 'application/json',
        data: JSON.stringify(body),
        // timeout: 100000,
        success: function(response) {
            // Handle success
            callback(null, response.data);
        },
        error: function(jqXHR, textStatus, errorThrown) {
            // Handle error
            console.error('Error:', textStatus, errorThrown);
            let err = {};
            err.type = 'global';
            err.message_key = 'Internal Error';
            err.jqXHR = jqXHR;
            err.message = jqXHR.responseJSON ? jqXHR.responseJSON.message : '';
            err.code = jqXHR.responseJSON ? jqXHR.responseJSON.code : '';
            err.textStatus = textStatus;
            err.errorThrown = errorThrown;
            console.error('err', JSON.stringify(err));
            callback(err, null);
        }
      });
  };

  this.cancel = function ( amount, taxAmount, storeId, terminalId, laneId, invoiceNumber, merchantReferenceCode, clientEnvironment, items, callback) {
    let body = {};
    let methodPath = '/fcc/cancel';
    body.amount = amount;
    body.taxAmount = taxAmount;
    body.storeId = storeId;
    body.terminalId = terminalId;
    body.laneId = laneId;
    body.invoiceNumber = invoiceNumber;
    body.merchantReferenceCode = merchantReferenceCode;
    body.clientEnvironment = clientEnvironment;
    body.items = items;
    $.ajax({
        url: url + methodPath,
        type: 'POST',
        contentType: 'application/json',
        data: JSON.stringify(body),
        // timeout: 100000,
        success: function(response) {
            // Handle success
            callback(null, response.data);
        },
        error: function(jqXHR, textStatus, errorThrown) {
            // Handle error
            console.error('Error:', textStatus, errorThrown);
            let err = {};
            err.type = 'global';
            err.message_key = 'Internal Error';
            err.jqXHR = jqXHR;
            err.message = jqXHR.responseJSON ? jqXHR.responseJSON.message : '';
            err.code = jqXHR.responseJSON ? jqXHR.responseJSON.code : '';
            err.textStatus = textStatus;
            err.errorThrown = errorThrown;
            console.error('err', JSON.stringify(err));
            callback(err, null);
        }
      });
  };

  this.checkOfflineTransactionStatus = function (requestId, callback) {
    let body = {};
    let methodPath = '/fcc/check-status';
    body.requestId = requestId;
    $.ajax({
        url: url + methodPath,
        type: 'POST',
        contentType: 'application/json',
        data: JSON.stringify(body),
        success: function(response) {
            // Handle success
            callback(null, response.data);
        },
        error: function(jqXHR, textStatus, errorThrown) {
            // Handle error
            console.error('Error:', textStatus, errorThrown);
            let err = {};
            err.type = 'global';
            err.message_key = 'Internal Error';
            err.jqXHR = jqXHR;
            err.message = jqXHR.responseJSON ? jqXHR.responseJSON.message : '';
            err.code = jqXHR.responseJSON ? jqXHR.responseJSON.code : '';
            err.textStatus = textStatus;
            err.errorThrown = errorThrown;
            console.error('err', JSON.stringify(err));
            callback(err, null);
        }
      });
  };

}
export default new FreedomPayApi();
